export default __webpack_public_path__ + "static/media/pp-img.ebd78876.webp";